
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ViewportSize from 'display/ViewportSize'
import { config, GlobalConfig, GlobalTheme } from 'display/config'
import { bus } from 'shared/state/Bus'
import { ServerState, ErgState, Erg } from 'shared/state'




@Component
export default class RoundAlert extends Vue {
	@ErgState() current_elimination_round: number

	showRoundAlert = false


	get alertStyle() {
		let style = {}
		switch (this.$route.name) {
			case 'leaderboard':
			case 'summary':
				// center horizontally
				style = {
					left: '50%',
					transform: 'translateX(-50%)'
				}
				break
			case 'race':
			case 'scroll':
			case 'participant':
			case 'spectator': {
				// leave
				style = {}
				break
			}
			// don't display on front page
			default: style = {display: 'none'}
		}

		return {
			...{ top: `calc(40vh + ${(ViewportSize.headerHeight  + ViewportSize.markerSize) / 2}px)` },
			...style
		}
	}

	@Watch('current_elimination_round')
	roundChanged(newVal, oldVal) {
		this.showRoundAlert = (newVal && newVal !== 1)
		setTimeout(() => this.showRoundAlert = false, 3000)

	}

}
